module.exports = __webpack_public_path__ + "img/emailsms_usuario.61759a6d.jpg";